// export const RUN_REPORT_DATA = 'RUN_REPORT_DATA';
export const REPORTS_VERIONS_ID_DATA = "REPORTS_VERIONS_ID_DATA";
export const RUN_PROCESSED_REPORT = "RUN_PROCESSED_REPORT";
export const RESET_RUN_REPORTS = "RESET_RUN_REPORTS";
